import axios from 'axios'

export const METRICOOL_BASE_URL = process.env.NODE_ENV === 'production' ? '/mc-api/' : 'https://app.metricool.com/api/'

const axiosMetricool = axios.create({
  baseURL: METRICOOL_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

axiosMetricool.interceptors.request.use((config) => {
  const apiKey = process.env.REACT_APP_METRICOOL_API_KEY

  // REQUIRED for Metricool
  if (process.env.NODE_ENV !== 'production') {
    config.headers['X-Mc-Auth'] = apiKey
  }

  return config
})

export default axiosMetricool
